import {combineReducers} from "redux";
import unitMemberViewModel from "./unitmember/UnitMemberViewModel";
import basicinfoViewModel from "./basicinfo/BasicInfoViewModel";
import manageViewModel from "./manage/ManageViewModel";
import mediGroupViewModel from "./mediGroupViewModel";

const rootViewModel = combineReducers({
    unitMemberViewModel,
    basicinfoViewModel,
    manageViewModel,
    mediGroupViewModel,
});

export default rootViewModel;
